import config from 'config';
import api from './api';

const acceptTerms = (): Promise<void> =>
  api.emptyPost(`${config.apiBaseUrl}/v1/user/terms/accept`, {});

export default { acceptTerms };
